// Design tokens — mapped to CSS custom properties for dark-mode support.
// All values are CSS var() references; actual colors live in index.css.

export const NEU_BG         = 'var(--surf)';
export const NEU_RAISED     = 'var(--shadow)';
export const NEU_PRESSED    = 'var(--shadow-pressed)';
export const NEU_SUBTLE     = 'var(--shadow-subtle)';
export const TEXT_PRIMARY   = 'var(--txt)';
export const TEXT_SECONDARY = 'var(--muted)';
export const TEXT_TERTIARY  = 'var(--faint)';
export const TEXT_FAINT     = 'var(--faint)';
export const ACCENT         = 'var(--accent)';
export const ACCENT_LIGHT   = 'var(--accent)';
export const ACCENT_BG      = 'var(--accent-bg)';
export const BORDER_SUBTLE  = 'var(--brd)';
export const BG_PAGE        = 'var(--bg)';
export const SURF_ALT       = 'var(--surf-alt)';
export const SURF_HOV       = 'var(--surf-hov)';
export const HDR_BG         = 'var(--hdr-bg)';
export const SIDEBAR_BG     = 'var(--sidebar-bg)';
export const SIDEBAR_BRD    = 'var(--sidebar-brd)';
export const COLOR_OK       = 'var(--ok)';
export const COLOR_WARN     = 'var(--warn)';
export const COLOR_DANGER   = 'var(--danger)';
export const COLOR_OK_BG    = 'var(--ok-bg)';
export const COLOR_WARN_BG  = 'var(--warn-bg)';
export const COLOR_DANGER_BG = 'var(--danger-bg)';
